"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Controllable = _interopRequireDefault(require("../../decorators/Controllable"));

var _Functions = require("../../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _focusStylesListener = require("../../listeners/focusStylesListener");

var _Props = require("../../utils/Props");

var _refObject = _interopRequireDefault(require("../../utils/propTypes/refObject"));

var UISelectWithInputAnchor = _react.default.createClass({
  displayName: "UISelectWithInputAnchor",
  propTypes: {
    autoFocus: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    error: _react.PropTypes.bool,
    menuWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
    inputComponent: _react.PropTypes.func.isRequired,
    inputRef: _refObject.default,
    isOpen: _react.PropTypes.bool.isRequired,
    onInputValueChange: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    placeholder: _react.PropTypes.string,
    readOnly: _react.PropTypes.bool,
    searchClassName: _react.PropTypes.string,
    selectComponent: _react.PropTypes.func.isRequired,
    selectRef: _react.PropTypes.func,
    inputValue: _react.PropTypes.string,
    value: _react.PropTypes.any
  },
  focus: function focus() {
    if (this._inputRef) {
      this._inputRef.focus();
    }
  },
  selectRefCallback: function selectRefCallback(ref) {
    var selectRef = this.props.selectRef;
    this._selectRef = ref;

    if (selectRef) {
      selectRef(ref);
    }
  },
  getInternalSelect: function getInternalSelect() {
    // Return our react-select component instance, or null
    if (!this._selectRef) {
      return null;
    }

    if (!this._selectRef.select) {
      return this._selectRef;
    } // _selectRef must be an <Async> or <Creatable> wrapper


    return this._selectRef.select;
  },
  getInternalAsyncSelect: function getInternalAsyncSelect() {
    // Return our react-select Async instance, or null
    if (!this._selectRef || !this._selectRef.select) {
      return null;
    }

    return this._selectRef;
  },
  handleInputKeyDown: function handleInputKeyDown(evt) {
    var readOnly = this.props.readOnly;
    var internalSelect = this.getInternalSelect();

    if (internalSelect && !readOnly) {
      internalSelect.handleKeyDown(evt);
    }
  },
  handleInputChange: function handleInputChange(evt) {
    var onInputValueChange = this.props.onInputValueChange;
    onInputValueChange(evt);
    var internalSelect = this.getInternalSelect();

    if (internalSelect) {
      internalSelect.handleInputChange(evt);
    }
  },
  handleInputFocus: function handleInputFocus() {
    var _this$props = this.props,
        onOpenChange = _this$props.onOpenChange,
        readOnly = _this$props.readOnly;
    var internalSelect = this.getInternalSelect();
    if (readOnly) return;

    if (internalSelect) {
      internalSelect.setState({
        isOpen: true
      });
    }

    (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent.default)(true));
  },
  handleInputBlur: function handleInputBlur() {
    var onOpenChange = this.props.onOpenChange;
    if (!(0, _focusStylesListener.isPageInKeyboardMode)()) return;
    (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent.default)(false));
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._inputRef = ref;
  },
  render: function render() {
    var _this$props2 = this.props,
        autoFocus = _this$props2.autoFocus,
        disabled = _this$props2.disabled,
        error = _this$props2.error,
        inputComponent = _this$props2.inputComponent,
        inputRef = _this$props2.inputRef,
        inputValue = _this$props2.inputValue,
        __onInputValueChange = _this$props2.onInputValueChange,
        __onOpenChange = _this$props2.onOpenChange,
        onPaste = _this$props2.onPaste,
        placeholder = _this$props2.placeholder,
        readOnly = _this$props2.readOnly,
        selectComponent = _this$props2.selectComponent,
        __selectRef = _this$props2.selectRef,
        tabIndex = _this$props2.tabIndex,
        value = _this$props2.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["autoFocus", "disabled", "error", "inputComponent", "inputRef", "inputValue", "onInputValueChange", "onOpenChange", "onPaste", "placeholder", "readOnly", "selectComponent", "selectRef", "tabIndex", "value"]);
    var InputComponent = inputComponent;
    var SelectComponent = selectComponent;
    return _react.default.createElement("div", null, _react.default.createElement(InputComponent, (0, _extends2.default)({}, (0, _Props.getAriaAndDataProps)(rest), {
      autoFocus: autoFocus,
      disabled: disabled,
      "aria-invalid": error,
      inputRef: inputRef,
      onBlur: this.handleInputBlur,
      onChange: this.handleInputChange,
      onFocus: this.handleInputFocus,
      onKeyDown: this.handleInputKeyDown,
      onPaste: onPaste,
      placeholder: placeholder,
      readOnly: readOnly,
      ref: this.inputRefCallback,
      tabIndex: tabIndex,
      value: inputValue
    })), _react.default.createElement(SelectComponent, (0, _extends2.default)({}, rest, {
      autosize: false,
      className: "hidden",
      disabled: disabled,
      ref: this.selectRefCallback,
      scrollMenuIntoView: false,
      value: value
    })));
  }
});

var _default = (0, _Controllable.default)(UISelectWithInputAnchor, ['inputValue']);

exports.default = _default;
module.exports = exports.default;